<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-24
    	描述：后台系统首页
    -->
  <div class="home" v-loading="loading">
    <!-- <div class="common-form mt16">
      商城统计
    </div> -->
    <div class="operation-wrap">
      <el-row>
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-shop-product'"></Icon>
            </div>
            <div class="info" @click="goto('product/product/index')">
              <h3>{{ tableData.product_total }}</h3>
              <p>服务总量</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6" v-if="supply_id==0">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-yonghu'"></Icon>
            </div>
            <div class="info" @click="goto('user/user/index')">
              <h3>{{ tableData.user_total }}</h3>
              <p>用户总量</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-shop-order'"></Icon>
            </div>
            <div class="info" @click="goto('order/order/index')">
              <h3>{{ tableData.order_total }}</h3>
              <p>订单总量</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6" v-if="supply_id==0">
          <div class="grid-content">
            <div class="pic">
              <Icon :iconname="'#icon-pingjia-tianchong'"></Icon>
            </div>
            <div class="info" @click="goto('product/comment/index')">
              <h3>{{ tableData.comment_total }}</h3>
              <p>评价总量</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 营销渠道 -->
    <!-- <div class="markert-wrap" v-if="show_marketing">
      <div class="common-form mt16">营销渠道</div>
      <el-row class="border-b">
        <el-col :span="6" v-for="app in marketing_app" :key="app.app_id">
          <div class="market">
            <div class="market-box" @click="gotoImg(app.link_url ? app.link_url : app.image.file_path)">
              <el-image :src="app.image.file_path"></el-image>
              <div>
                <p>{{ app.app_name }}</p>
              </div>
              <div>
                <p>{{ app.app_type }}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->


    <div class="home-index">
      <!--main-index-->
      <div class="main-index">
        <div class="common-form mt16">今日概况</div>

        <el-row class="border-b">
          <el-col :span="6">
            <div class="grid-content">
              <div class="pic">
                <Icon :iconname="'#icon-xiaoshou'"></Icon>
              </div>
              <div class="info">
                <h3>{{ order_total_price.tday }}</h3>
                <p class="des">销售额(元)</p>
                <p class="yesterday">昨日：{{ order_total_price.ytd }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <div class="pic">
                <Icon :iconname="'#icon-icon1'"></Icon>
              </div>
              <div class="info">
                <h3>{{ order_total.tday }}</h3>
                <p class="des">支付订单数</p>
                <p class="yesterday">昨日：{{ order_total.ytd }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" v-if="supply_id==0">
            <div class="grid-content">
              <div class="pic">
                <Icon :iconname="'#icon-xinzengyonghu'"></Icon>
              </div>
              <div class="info">
                <h3>{{ new_user_total.tday }}</h3>
                <p class="des">新增用户数</p>
                <p class="yesterday">昨日：{{ new_user_total.ytd }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <div class="pic">
                <Icon :iconname="'#icon-piliangxiadan'"></Icon>
              </div>
              <div class="info">
                <h3>{{ order_user_total.tday }}</h3>
                <p class="des">下单用户数</p>
                <p class="yesterday">昨日：{{ order_user_total.ytd }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!--side-->
      <div class="side"></div>
    </div>
  </div>
</template>

<script>
import IndexApi from "@/api/index.js";
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*统计信息*/
      tableData: [],
      /*总销售额(元)*/
      order_total_price: [],
      /*总支付订单数*/
      order_total: [],
      /*新增用户数*/
      new_user_total: [],
      /*下单用户数*/
      order_user_total: [],
      /*待办事项*/
      right_away: {
        order: [],
        cash: [],
        review: [],
        stock: [],
      },
      /*是否显示营销*/
      show_marketing: false,
      marketing_app: [],
      appImageList: [],
      supply_id:0,
    };
  },
  created() {
    /*获取数据*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      IndexApi.getCount({})
        .then((data) => {
          console.log(data);
          self.loading = false;
          self.tableData = data.data.data.widget_card;
          self.order_total_price =
            data.data.data.widget_outline.order_total_price;
          self.order_total = data.data.data.widget_outline.order_total;
          self.new_user_total = data.data.data.widget_outline.new_user_total;
          self.order_user_total = data.data.data.widget_outline.order_user_total;
          self.supply_id = data.data.supply_id;
          self.right_away = data.data.data.right_away;
          if (data.data.app[0].image) {
            self.show_marketing = true;
            self.marketing_app = data.data.app;
          }
        })
        .catch((error) => {});
    },
    /*点击菜单跳转*/
    goto(item) {
      if (item != null) {
        let path = item;
        this.$router.push(path);
      } else {
        this.$router.push("/");
      }
    },
    /*跳转图片*/
    gotoImg(item) {
      window.open(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.operation-wrap {
  width: 100%;
  height: 164px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 0 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #3a8ee6;
  background-size: 100% 100%;
  color: #fff;
}

.operation-wrap .grid-content {
  height: 164px;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.operation-wrap .grid-content h3 {
  font-size: 36px;
  line-height: 40px;
}

.operation-wrap .grid-content .info {
  margin-left: 10px;
}

.operation-wrap .grid-content .svg-icon {
  color: #ffffff;
}

.home-index {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  min-width: 1000px;
  overflow-x: auto;
}

.main-index {
  flex: 1;
}

.main-index .grid-content,
.operation-wrap .grid-content {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.main-index .grid-content {
  height: 120px;
}

.main-index .grid-content .pic {
  margin-right: 10px;
}

.main-index .grid-content h3 {
  font-size: 20px;
  font-weight: normal;
}

.main-index .grid-content .yesterday {
  color: #ccc;
}

.main-index .grid-content .svg-icon {
  color: #3a8ee6;
}

.matters-wrap .matters {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
}

.matters-wrap .matters .title {
  font-size: 14px;
  color: #fff;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  width: 40px;
  text-align: center;
  border-radius: 99px;
  margin-bottom: 20px;
  background: #3a8ee6;
}

.matters-wrap .matters ul {
  color: #999999;
}

.matters-wrap .matters ul span {
  padding-right: 6px;
  color: #3a8ee6;
}

.markert-wrap .market {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.markert-wrap .market-box {
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
}
.markert-wrap .market-box .el-image {
  width: 150px;
  height: 150px;
  margin-bottom: 2px;

}

.markert-wrap .market-box p {
  font-size: 14px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homex.vue